import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(CustomEase);

export default function InView() {
  return {
    init: () => {
      // const gsaps = [];

      const groups = {
        blocks: {
          trigger:
            '.w-b:not(.w-b-wrapper-start):not(.w-b-hero):not([class*="-list-item"])',
          target: '.w-b__inner',
          from: {
            opacity: 0,
            y: '-2rem',
          },
          to: { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' },
        },
        itemlist: {
          trigger: '.w-b-item-list',
          target: '[class*="-list-item"]',
          from: {
            opacity: 0,
            y: '-2rem',
          },
          to: {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power3.out',
            stagger: 0.025,
          },
        },
        flexlist: {
          trigger: '.w-b-flex-list',
          target: '.w-b-flex-list__item',
          from: {
            opacity: 0,
            y: '-2rem',
          },
          to: {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power3.out',
            stagger: 0.025,
          },
        },
        wrapper: {
          trigger: '.w-b-wrapper-start:not(:has(.w-b-hero))',
          target: false,
          from: {
            '--group-background-state': 0,
          },
          to: {
            '--group-background-state': 1,
            duration: 0.8,
            ease: 'power3.out',
          },
        },
        text: {
          trigger: '[data-w-trigger="paragraph"]',
          target: false,
          from: {
            opacity: 0,
            clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)',
          },
          to: {
            opacity: 1,
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            duration: 0.75,
            ease: 'power3.out',
          },
        },
      };

      Object.entries(groups).forEach(([index, group]) => {
        const triggers = document.querySelectorAll(group.trigger);
        if (triggers) {
          triggers.forEach((trigger) => {
            const target = group.target
              ? trigger.querySelectorAll(group.target)
              : trigger;

            gsap.fromTo(target, group.from, {
              ...group.to,
              scrollTrigger: {
                trigger: trigger,
                start: 'top 85%',
                // end: 'top 15%',
                // markers: true, // debug only
              },
            });
          });
        }
      });

      const imageContainers = document.querySelectorAll('.w-image-container');
      imageContainers.forEach((image) => {
        const trigger = image.closest('.w-image-container-trigger');

        gsap.fromTo(
          image,
          {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
            opacity: 0.25,
          },
          {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            opacity: 1,
            duration: 1,
            stagger: 0.5,
            ease: 'circ.inOut',
            scrollTrigger: {
              trigger: trigger,
              start: 'top 85%',
              // end: 'top 15%',
              // markers: true,
            },
          }
        );
      });

      const textTrigger = document.querySelectorAll(
        '[data-w-trigger-container]'
      );
      textTrigger.forEach((trigger) => {
        const textContainers = trigger.querySelectorAll(
          '[data-w-trigger="word"]'
        );

        textContainers.forEach((text) => {
          text.innerHTML = splitHtmlString(text.innerHTML, true);

          const timeline = gsap.timeline({
            scrollTrigger: {
              trigger: trigger,
              start: 'top 85%',
            },
          });

          const outerSpans = text.querySelectorAll('& > span');
          const innerSpans = text.querySelectorAll('& > span > span');
          gsap.set(innerSpans, {
            display: 'inline-block',
            position: 'relative',
          });

          timeline.fromTo(
            outerSpans,
            {
              opacity: 0,
              clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)',
            },
            {
              opacity: 1,
              clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
              duration: 0.75,
              stagger: 0.025,
              ease: 'power3.out',
            },
            0
          );
          timeline.fromTo(
            innerSpans,
            {
              translateY: '100%',
            },
            {
              translateY: 0,
              duration: 0.75,
              stagger: 0.025,
              ease: 'power3.out',
            },
            0
          );
        });
      });

      [
        'carListApp.loaded',
        'carListApp.updated',
        'carDetailApp.loaded',
        'carDetailApp.updated',
      ].forEach((event) => {
        document.addEventListener(event, () => {
          console.log('refresh ScrollTrigger');
          ScrollTrigger.refresh(true);
        });
      });
    },
  };
}
